import React from 'react';

import { useRouteError } from "react-router";
import { useNavigate } from "react-router";

const ErrorComponent = () => {
  const navigate = useNavigate();
  const error = useRouteError();

  const navigatetohome = () => {
    localStorage.clear();
    localStorage.removeItem("adminData");
    localStorage.removeItem("slotbook");
    navigate("/");
  };

  const message = error?.data ?? "Something went wrong";
  const statusText = error?.statusText ?? "Error";
  const statusCode = error?.status ?? "—";

  return (
    <>
      <div className="error-boundary">
        <div className="bar404" />
        <div className="error-box">
          <h3>{message}</h3>
          <p>Status Message: <span className="e404">{statusText}</span></p>
          <p>Status Code: <span className="e404">{statusCode}</span></p>
          <button type="button" className="go-back" onClick={navigatetohome}>
            Home
          </button>
          <hr className="line-hori" />
        </div>
      </div>
    </>
  );
};

export default ErrorComponent;
